
import { useCallback, useState } from 'react';
import { A2AMessage, MessageType } from '@/utils/a2a/types';
import { sendMessageToOrchestrator } from '@/services/orchestratorService';

export const useA2AMessageRouting = () => {
  const [isProcessing, setIsProcessing] = useState(false);

  const routeMessage = useCallback(async (message: {
    content: string;
    toAgent: string;
    metadata?: Record<string, any>;
  }): Promise<A2AMessage> => {
    console.log('A2A Protocol: Routing message to agent:', message.toAgent);
    
    try {
      setIsProcessing(true);

      // Route to orchestrator agent for real AI processing
      const response = await sendMessageToOrchestrator({
        content: message.content,
        targetAgent: message.toAgent === 'brig-ai' ? 'executive-agent' : message.toAgent,
        contextData: message.metadata
      });

      // Convert to A2A message format
      const a2aResponse: A2AMessage = {
        id: response.id,
        fromAgent: message.toAgent,
        toAgent: 'user',
        content: response.content,
        timestamp: response.timestamp,
        signature: '',
        keyId: '',
        metadata: {
          protocol: 'A2A',
          version: '1.1',
          messageType: 'RESPONSE' as MessageType,
          ...message.metadata
        }
      };

      return a2aResponse;

    } catch (error) {
      console.error('A2A Protocol error:', error);
      
      const errorResponse: A2AMessage = {
        id: `error-${Date.now()}`,
        fromAgent: message.toAgent,
        toAgent: 'user',
        content: `I encountered an error processing your request. Please try again or check your configuration.`,
        timestamp: new Date(),
        signature: '',
        keyId: '',
        metadata: {
          protocol: 'A2A',
          version: '1.1',
          messageType: 'ERROR' as MessageType,
          error: error.message
        }
      };
      
      return errorResponse;
      
    } finally {
      setIsProcessing(false);
    }
  }, []);

  return {
    routeMessage,
    isProcessing
  };
};
